<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/phagwa/Asset 51.png" alt="">
    
    <span v-show="selected_text == -1">
      <img draggable="false" id="eid_logo" src="./../../assets/images/phagwa/Asset 49.png">
      <img draggable="false" id="people" src="./../../assets/images/phagwa/Asset 50.png">
      <img draggable="false" class="clickable" id="eid_play_btn" @click="showText()" src="./../../assets/images/Asset 57.png" alt="">
    </span>

    <span v-show="selected_text >= 0">
      <span v-if="selected_text == 0" id="eid_game_text">Phagwa</span>
      <span v-html="texts[selected_text]" id="marron_game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>
      <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
      <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">

      <img v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true" draggable="false" @click="goToGame()" class="clickable" id="inheems_game_intro_btn" src="./../../assets/images/Asset 30.png" alt="">
    </span>
    
  </span>
</template>

<script>

export default {
  name: "PhagwaStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: -1,
      texts: [
        "Bij hun komst naar Suriname om als contractarbeiders op de plantage te werken, hebben de Hindoestanen hun cultuur en cultuuruitingen zoals de viering van feestdagen, met zich meegenomen. Het Holika of Phagwafeest is een nieuwjaarsfeest afkomstig uit India. Het is ontstaan in een gebied met een gematigd klimaat. In deze gebieden wordt het nieuwe jaar ingeluid met de lente. In de winter is de levende natuur min of meer tot stilstand gekomen, de meeste bomen staan er kaal bij. Dan breekt de lente door. De zon komt terug en het wordt warmer. De natuur ontwaakt uit zijn winterslaap, de bomen en struiken krijgen weer bladeren en dragen bloemen. Overal is er opeens weer kleur die de grauwe winter kleur verdrijft.",

        "Er zijn verschillende kleuren te zien. Al deze bloemen en verse bladeren geuren in verschillende aroma’s. Vandaar dat mensen die dit natuurgebeuren vieren elkaar met geur en kleurstoffen besprenkelen. De poeder die men over elkaar strooit symboliseert het stuifmeel dat door de bloemen verspreid wordt.",

        "Een feest houdt een boodschap in. De mens is deel van de schepping en is zodoende innig verbonden met de gebeurtenissen in de natuur. Zon, maan, regen, wind en jaargetijden laten de mens niet onberoerd. Integendeel drukken zij in belangrijke mate invloed uit op het gedrag en het gevoel van mens en dier. Moeder natuur komt met Phagwa weer tot leven, moeder natuur is jarig. Wij mensen die allemaal afhankelijk zijn van moeder natuur vieren dit feest mee. Wij symboliseren deze wederopstanding door elkaar met kleur-, geurstoffen en poeder te bestuiven. Wij symboliseren daarmee de overwinning van het leven op de dood, van het goede op het kwade, van licht op duisternis, van kennis op onwetendheid, van recht op onrecht.",

        "Het feest accentueert en bevordert universelemenselijke waarden als goedheid, waarheid,oprechtheid, eerlijkheid, liefde rechtvaardigheid, moraliteit, reine levenswandel, harmonie, rust en vrede.",

        "Wist je dat elk jaar, wanneer we Paghwa vieren, we iets heel bijzonders doen? We maken een enorme brandstapel genaamd Holika. Maar waarom? Omdat Holika ons helpt om van slechte dingen af te komen! <br><br> Nu komt het leuke gedeelte: we kunnen symbolisch dingen die we niet leuk vinden of die ons verdrietig maken opschrijven op papiertjes en die dan in de Holika-brandstapel stoppen. Zo worden al die vervelende dingen verbrand, net als magie! Misschien schrijf je wel iets als \"boosheid\" of \"verdriet\" op een papiertje. Zodra het in de vlammen van Holika verdwijnt, voel je je lichter en gelukkiger!",

        "Dus, laten we samen onze eigen Holika maken en al die nare dingen wegjagen. Paghwa wordt nog specialer als we samen lachen, spelen en onze vrolijke gedachten delen. Vergeet niet, het is tijd om de goede energie te omarmen en de slechte dingen in de vlammen van Holika te laten verdwijnen."
      ]
    };
  },

  methods: {
    goToStart() {
      this.$router.push('/start');
    },
    goToGame() {
      this.$router.push('/phagwa/game');
    },

    showText() {
      this.selected_text = 0
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },
  },

  computed: {}
};
</script>

<style>
  #eid_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #eid_play_btn {
    position: absolute;
    margin-top: 22%;
    left: 44%;
    width: 15%;
  }
  #eid_logo {
    position: absolute;
    margin-top: 5%;
    left: 28%;
    width: 45%;
  }
  #people {
    position: absolute;
    margin-top: 19.4%;
    left: 18.5%;
    width: 62%;
  } 
</style>


